// Shared canvas basics for the carousel: slide size and small drawing helpers.

// LinkedIn portrait carousel, drawn at full resolution.
export const CANVAS_W = 1080;
export const CANVAS_H = 1350;

// Space between the slide edge and the content.
export const PAD = 90;

export const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

// 1 -> "01"
export const pad2 = (n) => String(n).padStart(2, "0");

// Splits text into lines that fit maxWidth with the current ctx.font.
export function wrapText(ctx, text, maxWidth) {
  const words = String(text || "").split(/\s+/).filter(Boolean);
  const lines = [];
  let line = "";
  for (const w of words) {
    const test = line ? `${line} ${w}` : w;
    if (ctx.measureText(test).width > maxWidth && line) {
      lines.push(line);
      line = w;
    } else {
      line = test;
    }
  }
  if (line) lines.push(line);
  return lines;
}

// Rounded rectangle path. Call ctx.fill() or ctx.stroke() after it.
export function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}